import * as React from 'react';

function SvgHelpCenterMyAccount(props) {
  return (
    <svg width={63} height={62} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none">
        <path
          d="M32.417 6.52c8.132 0 14.718 6.586 14.718 14.719 0 5.28-2.8 9.906-6.994 12.491a25.382 25.382 0 015.638 2.518l1.101-1.037c.87-.815 2.19-.816 3.016.008l11.591 11.205c.429.43.654.977.654 1.58v11.203c0 1.205-.985 2.19-2.19 2.19h-1.949v.003H7.198A25.852 25.852 0 017 58.2c0-8.736 4.376-16.45 11.055-21.07a22.993 22.993 0 016.508-3.48l-.403-.264a14.658 14.658 0 01-6.462-12.147c0-8.105 6.6-14.719 14.719-14.719z"
          fill="#E2F4F2"
        />
        <path
          d="M38.702 28.551l11.59 11.206c.43.429.654.977.654 1.58v11.202c0 1.206-.984 2.19-2.19 2.19h-23.56a2.195 2.195 0 01-2.19-2.19V41.422c0-.606.27-1.21.706-1.59l11.974-11.289c.87-.815 2.189-.816 3.016.008zM24.897.6c8.132 0 14.718 6.586 14.718 14.719 0 7.968-6.376 14.445-14.293 14.67l-.533.005-.503-.013c-11.755.295-20.16 9.826-20.16 22.943a1.74 1.74 0 01-1.763 1.763A1.74 1.74 0 01.6 52.924c0-7.356 2.445-14.096 6.882-18.925a23.136 23.136 0 019.56-6.27l-.402-.263a14.658 14.658 0 01-6.462-12.147C10.178 7.214 16.778.6 24.897.6zm12.267 31.352L26.53 41.97v9.233h8.874v-6.195c0-.992.771-1.762 1.763-1.762.926 0 1.66.67 1.753 1.567l.01.195-.001 6.194h8.49v-9.321l-10.256-9.93zM24.897 4.126c-6.164 0-11.194 5.016-11.194 11.193 0 5.849 4.48 10.64 10.228 11.111l.385.025.538-.008.138.005.136.015.379-.014A11.18 11.18 0 0036.09 15.276c0-6.168-5.02-11.15-11.193-11.15z"
          fill="#38B2A6"
        />
      </g>
    </svg>
  );
}

export default SvgHelpCenterMyAccount;
